import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

// Importing zodiac sign images
import ariesImage from "../assets/zodiacSign/aries.png";
import taurusImage from "../assets/zodiacSign/taurus.png";
import geminiImage from "../assets/zodiacSign/gemini.png";
import cancerImage from "../assets/zodiacSign/cancer.png";
import leoImage from "../assets/zodiacSign/leo.png";
import virgoImage from "../assets/zodiacSign/virgo.png";
import libraImage from "../assets/zodiacSign/libra.png";
import scorpioImage from "../assets/zodiacSign/scorpio.png";
import sagittariusImage from "../assets/zodiacSign/sagittarius.png";
import capricornImage from "../assets/zodiacSign/capricorn.png";
import aquariusImage from "../assets/zodiacSign/aquarius.png";
import piscesImage from "../assets/zodiacSign/pisces.png";
import zodiac from "../assets/zodiacSign/zodiac.png";
import weekly from "../assets/zodiacSign/weekly.png";
import yearly from "../assets/zodiacSign/yearly.png";
import solarsystem from "../assets/rootimg/kundli2.jpg";
import lovetarotImage from "../assets/zodiacSign/lovetarot.png";
import dailytarotImage from "../assets/zodiacSign/dailytarot.png";
import weeklytarotImage from "../assets/zodiacSign/weeklytarot.png";
import careertarotImage from "../assets/zodiacSign/careertarot.png";
import Navbar from './Navbar';
import Queryform from '../pages/Queryform';

import { API_URL , API_END_POINT } from '../pages/Utils/Constant';

const HomePage = () => {
    const navigate = useNavigate();
    const [isActive, setIsActive] = useState(null);
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    const tarotClick = (e) => {
        e.preventDefault();
        navigate('/tarot');
    }
    const kundlimatchinghandler = (e) => {
        e.preventDefault();
        navigate('/kundlimatching');
    }
    const kundlihandler = (e) => {
        e.preventDefault();
        navigate('/new-kundli');
    }
    const horoscopehandler = (e) => {
        e.preventDefault();
        navigate('/horoscope');
    }
    const zodiachandler = (e, sign) => {
        e.preventDefault();
        navigate('/yearly-horoscope', { state: { zodiacSign: sign.name } });
    }
    const natalhandler = (e) => {
        e.preventDefault();
        navigate('natalchart');
    }

    const zodiacSigns = [
        { name: 'Aries', date: 'Mar 21 - Apr 19', image: ariesImage },
        { name: 'Taurus', date: 'Apr 20 - May 20', image: taurusImage },
        { name: 'Gemini', date: 'May 21 - Jun 20', image: geminiImage },
        { name: 'Cancer', date: 'Jun 21 - Jul 22', image: cancerImage },
        { name: 'Leo', date: 'Jul 23 - Aug 22', image: leoImage },
        { name: 'Virgo', date: 'Aug 23 - Sep 22', image: virgoImage },
        { name: 'Libra', date: 'Sep 23 - Oct 22', image: libraImage },
        { name: 'Scorpio', date: 'Oct 23 - Nov 21', image: scorpioImage },
        { name: 'Sagittarius', date: 'Nov 22 - Dec 21', image: sagittariusImage },
        { name: 'Capricorn', date: 'Dec 22 - Jan 19', image: capricornImage },
        { name: 'Aquarius', date: 'Jan 20 - Feb 18', image: aquariusImage },
        { name: 'Pisces', date: 'Feb 19 - Mar 20', image: piscesImage },
    ];
    const services = [
        { title: "Daily Horoscope", image: zodiac, link: "/daily-horoscope" },
        {title: "Weekly Horoscope", image: weekly, link: "/weekly-horoscope" },
        { title: "Yearly Horoscope", image: yearly, link: "/yearly-horoscope" },
        { title: "Personalized Horoscope", image: solarsystem, link: "/blog" },
    ];
    const cards = [
        { title: "Work Compatibility", icon: "⚙️", link: "/work/compatibility" },
        { title: "Love Compatibility", icon: "♓", link: "/love/compatibility" },
        { title: "Chinese Compatibility", icon: "☯️", link: "/chinese/compatibility" },
        { title: "Personality Traits & More", icon: "♈", link: "/comming-soon" },
    ];
    const newcards = [
        { title: "Love Tarot", img: lovetarotImage, link: "/love/tarot" },
        { title: "Daily Tarot", img: dailytarotImage, link: "/daily/tarot" },
        { title: "Yes/No Tarot", img: weeklytarotImage, link: "/yes&no/tarot" },
        { title: "career Tarot", img: careertarotImage, link: "/career/tarot" }
    ]


    // Fetch blogs from API
    useEffect(() => {
        const fetchBlogs = async () => {    
            try {
                setLoading(true);
                const response = await axios.get(`${API_END_POINT}astroblog/`);
                
                // Get random 6 blogs from the response
                const allBlogs = response.data;
                const shuffled = [...allBlogs].sort(() => 0.5 - Math.random());
                const randomBlogs = shuffled.slice(0, 6);
                
                setBlogs(randomBlogs);
                setLoading(false);
            } catch (err) {
                console.error('Error fetching blogs:', err);
                setError('Failed to load blogs. Please try again later.');
                setLoading(false);
            }
        };
        
        fetchBlogs();
    }, []);

    const Card = ({ title, description, image, _id }) => {
        return (
            <div className="bg-white rounded-lg shadow-md p-4 flex gap-4 items-start">
                {/* Image */}
                <img 
                    src={image || 'https://via.placeholder.com/300x200?text=No+Image'} 
                    alt={title} 
                    className="w-32 h-32 rounded-lg object-cover" 
                />
                {/* Text Content */}
                <div>
                    <h2 className="text-lg font-bold">{title}</h2>
                    <p className="text-gray-600 line-clamp-2">{description}</p>
                    <Link to={`/blog/${_id}`} className="text-blue-600 font-medium mt-2 inline-block">
                        READ MORE →
                    </Link>
                </div>
            </div>
        );
    };

    return (
        <>
            <section className=' bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen'>
                <Navbar />
                <main>
                    <h1 className="text-secondary/90 text-4xl pt-16 font-serif text-center font-bold mb-4">Welcome to AstroTellers</h1>
                    <p className="text-xl text-secondary font-serif text-center mb-8">Choose your sign</p>
                    <div className=' flex justify-center items-center text-center  '>
                        {/* Zodiac Sign Section */}
                        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 md:gap-7 lg:gap-7 p-2 gap-0 ">
                            {zodiacSigns.map((sign, index) => (
                                <div key={index} className="flex flex-col items-center hover:bg-white p-3 hover:shadow-custom-shadow rounded-lg transition "
                                    onMouseEnter={() => setIsActive(index)}
                                    onMouseLeave={() => setIsActive(null)}
                                    onClick={(e) => zodiachandler(e, sign)}
                                >
                                    <img
                                        src={sign.image}
                                        alt={sign.name}
                                        className={`lg:w-16 lg:h-16 md:w-16 md:h-16 sm:w-10 sm:h-10 w-10 h-10 object-cover mb-2 `}
                                    />
                                    <h2
                                        className={`text-lg font-semibold font-serif text-primary ${isActive === index ? "underline" : ""
                                            }`}
                                    >
                                        {sign.name}
                                    </h2>
                                    <p className=" text-sm text-primary ">{sign.date}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <p className="text-center font-serif max-w-6xl mx-auto text-primary text-lg mt-8">
                        Learn about astrology, zodiac signs, retrogrades, and more! Your world becomes clear once you understand how the universe influences it.
                    </p>

                    {/* Blog Section */}
                    <div className="py-8 px-4">
                        
                        {loading ? (
                            <div className="flex justify-center items-center h-40">
                                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-secondary"></div>
                            </div>
                        ) : error ? (
                            <div className="bg-red-50 border-l-4 border-red-500 p-4 max-w-6xl mx-auto">
                                <p className="text-red-700">{error}</p>
                            </div>
                        ) : blogs.length === 0 ? (
                            <div className="text-center max-w-6xl mx-auto">
                                <p className="text-gray-600">No blogs available at the moment.</p>
                            </div>
                        ) : (
                            <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                {blogs.map((blog) => (
                                    <Card 
                                        key={blog._id} 
                                        title={blog.title} 
                                        description={blog.content} 
                                        image={blog.image} 
                                        _id={blog._id}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                    
                    {/* Call-to-Action Section */}
                    <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 px-4 md:px-16 lg:px-44">
                        {/* Birth Chart Section */}
                        <div className="bg-white p-6 rounded-lg hover:shadow-xl hover:shadow-gray-400 shadow-md text-center">
                            <h2 className="font-bold text-2xl text-secondary mb-4">
                                Free Birth Chart Natal Chart Report
                            </h2>
                            <p className="text-gray-700 mb-4">
                                Discover the key to your life path & personality
                            </p>
                            <button onClick={natalhandler} className="bg-secondary text-white px-6 py-2 rounded-lg shadow hover:bg-secondary/90 w-full sm:w-auto">
                                Calculate Your Free Birth Chart
                            </button>
                        </div>

                        {/* Tarot Reading Section */}
                        <div className="bg-white p-6 rounded-lg hover:shadow-xl hover:shadow-gray-400 shadow-md text-center">
                            <h2 className="font-bold text-2xl text-secondary mb-4">
                                Yes / No Free Tarot Reading
                            </h2>
                            <p className="text-gray-700 mb-4">
                                Get an answer with actionable advice!
                            </p>
                            <button
                                onClick={tarotClick}
                                className="bg-secondary text-white px-6 py-2 rounded-lg shadow hover:bg-secondary/90 w-full sm:w-auto"
                            >
                                Pick a Card and Get an Answer
                            </button>
                        </div>
                    </div>

                    {/* Explore Astrology Button */}
                    {/* Explore Button */}
                    {/* <div className="flex justify-center mt-8">
                        <button className="bg-secondary text-white px-8 mx-4 sm:px-12 lg:px-16 py-3 rounded-lg shadow hover:bg-success w-full sm:w-auto">
                            Explore Astrology
                        </button>
                    </div> */}
                    {/* Horoscope Section  */}
                    <div className="text-center pt-10 px-4">
                        <h1 className="text-secondary text-2xl font-serif md:text-3xl lg:text-4xl font-bold">
                            Horoscope Services
                        </h1>
                        <p className="text-lg md:text-xl font-serif mt-2 max-w-3xl mx-auto">
                            Explore the secrets of the universe through our horoscopes! Let our celestial insights guide you in preparing for what lies ahead.
                        </p>
                    </div>

                    <div className="min-h-screen p-6 flex flex-col items-center">
                        <h1 className="text-2xl font-bold text-center text-secondary mb-6">
                            COMPLIMENTARY HOROSCOPE SERVICES
                        </h1>

                        {/* Services Grid */}
                        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 max-w-6xl mx-auto">
                            {services.map((service, index) => (
                                <div
                                    key={index}
                                    className="bg-white shadow-md rounded-lg p-6 hover:shadow-xl hover:shadow-gray-400 text-center transition-shadow duration-300"
                                >
                                    <div className="flex flex-col justify-center items-center">
                                        <img
                                            src={service.image}
                                            alt={service.name}
                                            className="w-24 h-24 object-cover rounded-md"
                                        />
                                    </div>
                                    <div className="mt-3">
                                        <h2 className="text-lg font-semibold text-gray-700">
                                            {service.title}
                                        </h2>
                                        <Link to={service.link} className="text-blue-600 text-sm mt-1 inline-block" href="#">
                                            READ MORE →
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Buttons Section */}
                        <div  className="flex flex-col sm:flex-row justify-center gap-6 mt-10 px-4">
                            <button onClick={horoscopehandler} className="bg-secondary text-white w-full sm:w-auto px-6 md:px-12 lg:px-24 py-2 rounded-lg shadow hover:bg-secondary/90">
                                Explore Horoscope
                            </button>
                           
                        </div>
                        {/* Compatibility Sections */}
                        <div className="text-gray-800 py-16 px-4 md:px-8 lg:px-16">
                            <div className="max-w-6xl mx-auto text-center">
                                {/* Heading */}
                                <h2 className="text-3xl font-bold font-serif text-secondary mb-2">Compatibility Services</h2>

                                {/* Description */}
                                <div className="flex justify-center">
                                    <p className="text-lg font-serif sm:text-xl max-w-3xl mb-10">
                                        "Explore your compatibility and discover how your relationships with your partner, colleagues,
                                        friends, and family measure up in terms of love and work dynamics."
                                    </p>
                                </div>

                                {/* Main Content Grid */}
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                    {/* Left Section */}
                                    <div className="bg-pink-300 text-pink-800 rounded-lg p-6 flex flex-col justify-between shadow text-center">
                                        <h3 className="text-xl font-bold mb-4">
                                            Are you and your love interest meant to be?
                                        </h3>
                                        <p className="text-sm mb-6">Choose a Sign and find out now!</p>
                                        <button onClick={() =>navigate('/compatibility')} className="bg-white text-pink-700 px-6 py-2 rounded-lg font-medium shadow hover:bg-gray-100 w-full sm:w-auto">
                                            Check Our Compatibility
                                        </button>
                                    </div>

                                    {/* Right Section */}
                                    <div className="col-span-1 md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
                                        {cards.map((card, index) => (
                                            <div
                                                key={index}
                                                className="bg-white shadow rounded-lg p-6 flex justify-between items-center hover:shadow-md transition-shadow"
                                            >
                                                <div>
                                                    <h3 className="text-lg text-secondary font-semibold">{card.title}</h3>
                                                    <Link to={card.link} className="text-blue-500 text-sm font-medium mt-2 block">
                                                        Read More →
                                                    </Link>
                                                </div>
                                                <span className="text-4xl text-gray-400">{card.icon}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Explore Button */}
                                {/* <div className="flex justify-center mt-8">
                                    <button className="bg-secondary text-white px-8 sm:px-12 lg:px-16 py-3 rounded-lg shadow hover:bg-success w-full sm:w-auto">
                                        Explore Compatibility
                                    </button>
                                </div> */}
                            </div>
                        </div>
                        {/* Tarot Sections */}
                        <div className="text-gray-800 py-2 px-4 md:px-8 lg:px-16">
                            <div className="max-w-6xl mx-auto text-center">
                                {/* Heading */}
                                <h2 className="text-3xl font-bold font-serif text-secondary mb-4">Explore Tarot</h2>

                                {/* Description */}
                                <div className="flex justify-center">
                                    <p className="text-lg sm:text-xl font-serif max-w-3xl -mt-2 mb-10">
                                        Discover and uncover the deeper meaning and insights hidden within your past, present, and future through
                                        a profound and insightful Tarot reading that will guide you on your journey of self-awareness and understanding.
                                    </p>
                                </div>

                                {/* Main Content Grid */}
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                    {/* Left Section */}
                                    <div className="bg-blue-300 text-blue-800 rounded-lg p-6 flex flex-col justify-between shadow text-center">
                                        <h3 className="text-xl font-bold mb-4">
                                            Experience a live, personalized Tarot reading.
                                        </h3>
                                        <p className="text-sm mb-6">
                                            Let the Tarot cards provide you with the guidance and advice you are seeking.
                                        </p>
                                        <button
                                            onClick={tarotClick}
                                            className="bg-white text-blue-700 px-6 py-2 rounded-lg font-medium shadow hover:bg-gray-100 w-full sm:w-auto"
                                        >
                                            Start My Reading
                                        </button>
                                    </div>

                                    {/* Right Section */}
                                    <div className="col-span-1 md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
                                        {newcards.map((newcard, index) => (
                                            <div
                                                key={index}
                                                className="bg-white shadow rounded-lg p-6 flex justify-between items-center hover:shadow-md transition-shadow"
                                            >
                                                <div className="ml-0 md:ml-6">
                                                    <h3 className="text-lg text-secondary font-semibold">{newcard.title}</h3>
                                                    <Link to={newcard.link} className="text-blue-500 text-sm font-medium mt-2 block">
                                                        Read More →
                                                    </Link>
                                                </div>
                                                <img
                                                    src={newcard.img}
                                                    alt={newcard.title}
                                                    className="w-16 h-16 rounded-md object-cover"
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Explore Button */}
                                <div className="flex justify-center mt-8">
                                    <button
                                        onClick={tarotClick}
                                        className="bg-secondary text-white px-8 sm:px-12 lg:px-16 py-3 rounded-lg shadow hover:bg-success w-full sm:w-auto"
                                    >
                                        Explore Tarot Reading
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/* Kundli Sections */}
                        <div className="flex justify-center items-center px-4 md:px-16 mt-6 lg:px-32">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-5xl">
                                {/* Create Kundli Card */}
                                <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl hover:shadow-gray-400 text-center">
                                    <h2 className="font-bold text-2xl text-secondary mb-4">Create Your Free Kundli</h2>
                                    <p className="text-gray-700 mb-2">
                                        Uncover the secrets to your life path and personality.
                                    </p>
                                    <button
                                        onClick={kundlihandler}
                                        className="bg-secondary text-white px-6 py-2 rounded-lg shadow hover:bg-secondary/90 w-full sm:w-auto"
                                    >
                                        View Your Free Kundli
                                    </button>
                                </div>

                                {/* Kundli Matching Card */}
                                <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl hover:shadow-gray-400 text-center">
                                    <h2 className="font-bold text-2xl text-secondary mb-4">Kundli Matching</h2>
                                    <p className="text-gray-700 mb-4">
                                        Connect with loved ones and find your perfect match.
                                    </p>
                                    <button
                                        onClick={kundlimatchinghandler}
                                        className="bg-secondary text-white px-6 py-2 rounded-lg shadow hover:bg-secondary/90 w-full sm:w-auto"
                                    >
                                        Kundli Matching
                                    </button>
                                </div>
                            </div>
                        </div>
                        <Queryform />
                    </div>
                </main>
            </section>
        </>
    )
}

export default HomePage